import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class ProgressBar extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      percent: {type: `number`, description: `Percentage progress out of 100`},
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      helpers: {
        getPercentStatus: () => {
          return Math.min(100, this.attr(`percent`));
        },
      },
    };
  }
}

export const ProgressBarEl = defineAndMakeJsxFactory(`mp-progress-bar`, ProgressBar);
